import { css } from '@emotion/react';

export const cookieBotStyles = css`
  #CybotCookiebotDialog .CookieCard {
    border-bottom: none !important;
  }

  #CybotCookiebotDialog .CookieCard:not(:first-child) {
    display: none;
  }

  a#CybotCookiebotDialogPoweredbyCybot {
    display: none;
  }
`;
